import { useLang, tx } from "@/context/LangContext";
import { SERVICES, T } from "@/data/content";
import { FadeUp, SectionLabel, BlurBackdrop, SlideIn } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

// where each service row leads
const SERVICE_TARGETS = {
    "01": "contact", // direction créative → discuter du projet
    "02": "videos", // film & vidéo → portfolio vidéo
    "03": "photo", // photographie → galerie photo
    "04": "contact", // marketing visuel → tarifs/ads
    "05": "contact", // stratégie → tarifs/ads
    "06": "videos", // création de contenu → portfolio vidéo
};

export default function Services() {
    const { lang } = useLang();

    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative bg-[#101014] py-24 text-cream md:py-36"
        >
            <BlurBackdrop src="/img/gear-arsenal.jpg" tint="bg-[#101014]/70" />
            <div className="mx-auto max-w-[1600px] px-5 md:px-10">
                <SectionLabel en={tx(lang, T.services.label)} fr={tx(lang, T.services.label)} />
                <FadeUp delay={0.1}>
                    <h2 className="mt-8 font-display text-[clamp(2.6rem,8vw,7rem)] font-extrabold uppercase leading-none tracking-[-0.02em]">
                        {tx(lang, T.services.title)}
                        <span className="text-violet">.</span>
                    </h2>
                </FadeUp>

                <div className="mt-14 md:mt-20">
                    {SERVICES.map((s, i) => (
                        <SlideIn key={s.num} delay={i * 0.06} from={i % 2 ? 60 : -60}>
                            <button
                                data-testid={`service-row-${i}`}
                                data-cursor="VOIR"
                                onClick={() => window.__goPage?.(SERVICE_TARGETS[s.num] || "videos")}
                                className={`group relative block w-full overflow-hidden border-t border-white/15 text-left ${
                                    i === SERVICES.length - 1 ? "border-b" : ""
                                }`}
                            >
                                <div className="absolute inset-0 translate-y-full bg-cream transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:translate-y-0" />
                                <div className="relative z-10 grid grid-cols-12 items-center gap-3 px-1 py-7 md:gap-6 md:py-9">
                                    <span className="col-span-2 font-mono text-[10px] tracking-[0.3em] text-cream/40 transition-colors duration-500 group-hover:text-violet md:col-span-1 md:text-xs">
                                        {s.num}
                                    </span>
                                    <h3 className="col-span-10 font-display text-xl font-extrabold uppercase tracking-tight transition-all duration-500 group-hover:translate-x-3 group-hover:text-ink md:col-span-4 md:text-3xl">
                                        {s.title[lang]}
                                    </h3>
                                    <p className="col-span-10 col-start-3 text-xs font-light leading-relaxed text-cream/55 transition-colors duration-500 group-hover:text-ink/70 md:col-span-5 md:col-start-6 md:text-sm">
                                        {s.desc[lang]}
                                    </p>
                                    <span className="col-span-12 flex justify-end md:col-span-2 md:justify-center">
                                        <ArrowUpRight
                                            size={22}
                                            className="text-cream/30 transition-all duration-500 group-hover:rotate-45 group-hover:scale-125 group-hover:text-violet"
                                        />
                                    </span>
                                </div>
                            </button>
                        </SlideIn>
                    ))}
                </div>
            </div>
        </section>
    );
}
